<template>
  <div id="modal-template">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <button tabindex="3" @click="$emit('close')" aria-label="close" class="closer vz-button-link"
              data-loc="Content:Button:Verizon and AWS improve Orion’s performance:Close button">X</button>
            <div class="modal-body">
              <slot name="body">
                <div class="modal-table">
                  <div
                    class="modal-row"
                  >[New innovations will push the game possibilities to the edge.]</div>
                  <div class="modal-row">
                    <span class="col-sm-3">Robert Duffy:</span> At some point in the not-to-distant future, game streaming will be the dominant delivery mechanism.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Shale Williams:</span> We're seeing quite a shift in the industry right now. Cloud gaming is becoming more mainstream, and you want to be in the game, and not notice any lag, and basically just forget that you're streaming a game.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> We try to always push technology to its absolute limits so that we can provide the absolute best interactive entertainment experiences that are possible.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Shale Williams:</span> It's a dream job. Just like a huge, magical place that a lot of people want to be involved in.
                  </div>
                  <div
                    class="modal-row"
                  >[With Orion, the gaming industry is poised for a massive disruption.]</div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> What Orion does is it enables that super high-speed, fluid game playwith rich textures and in high resolution, and at a fast framerate that we want our gamers to have as they are playing from the cloud.
                  </div>
                  <div class="modal-row">[Until now, high-end game streaming was only a pipe dream.]</div>
                  <div class="modal-row">
                    <span class="col-sm-3">Robert Duffy:</span> Game streaming is a killer app for 5G because it's gonna let gamers do gaming when they want, how they want, and with little to no perceived latency.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> If you can't provide a low-latency experience it's not even worth attempting. And if you can't provide it at a bandwidth that's acceptable, it's neither good for the service provider, nor for the consumer.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Robert Duffy:</span> You've got to have hardware in the cloud, at the edge, and you have to have a way to deliver it.
                  </div>
                  <div
                    class="modal-row"
                  >[Verizon 5G Edge and Amazon Web Services enable groundbreaking cloud performance.]</div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> When you Bethesda's Orion technology, and Verizon's 5G Edge with AWS, what you have are complementary technologies that will enable us to bring our games to our consumers in the best possible way.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Robert Duffy:</span> I see that, I want to play it, I press "play" and I'm playing instantly. That's what gamers want.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> I can play games on devices I already own, like phones and smart TVs, and stream triple-A content at max settings directly to myself.
                  </div>
                  <div class="modal-row">[Bethesda chose DOOM to put Orion streaming to the test.]</div>
                  <div class="modal-row">
                    <span class="col-sm-3">Shale Williams:</span> DOOM is the ultimate test for streaming because it's very fast, stuffgoing on all the time. It's 60 FPS, which was totally unthinkable for getting running in streaming. If you get DOOM working on streaming, you can get anything working.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> Verizon was the best choice for Bethesda because they have a network that is built right, and has compute on the edge exactly where we need it.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Robert Duffy:</span> I don't see 4K and 8K being problems as we go forward.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">James Altman:</span> With all of that compute power and resources and speed and bandwidth all right there at the edge, there are going to be some new interesting, creative things that will be coming out in the next three to five years.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Shale Williams:</span> Bigger worlds, crazier things will happen.
                  </div>
                  <div class="modal-row">
                    <span class="col-sm-3">Robert Duffy:</span> I can build something that you've never seen, and that you've only dreamed of playing. And that's what we want to do.
                  </div>
                  <div
                    class="modal-row"
                  >[If Verizon can do this for gaming, imagine what it can do for your business.]</div>
                  <div class="modal-row x">[5G Edge]</div>
                  <div class="modal-row x">[Verizon]</div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "TranscriptModal"
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-height: 400px;
  overflow-y: scroll;
}

.closer {
  position: relative;
  top: 0;
  left: 95%;
  background: transparent;
  border: none;
  transition: all 1s;
  z-index: 9;
  padding: 0;

  &:hover {
    transform: scale(1.5);
  }
}

.modal-body {
  margin: 20px 0;
  font-size: 18px;
}

.modal-table {
  display: table;
}

.modal-row {
  display: block;
  color: #aaa;
  margin-top: 10px;

  span {
    font-weight: bold;
    padding-left: 0;
  }

  &.x {
    display: block;
  }
  &:focus {
    color: #000;
  }

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>